angular.module('bmsApp.settings').controller('StripeConfigurationCtrl', [
	'$scope',
	'$log',
	'AppSettingsSvc',
	'notify',
	'$timeout',
	function ($scope, $log, AppSettingsSvc, notify, $timeout) {

		$scope.settingData = {};
		$scope.loaded = false;
		$scope.validateAttempted = false;

		AppSettingsSvc.index()
			.then(function (response) {
				$scope.settingData = response.data.settings;
				$scope.loaded = true;
			}, function (error) {
				$scope.errors = error;
			});

		$scope.verifyKey = function() {

		};

		$scope.validateKeys = () => {
			$scope.validating = true;
			$scope.publishableKeyValidated = false;
			$scope.secretKeyValidated = false;
			AppSettingsSvc.validateStripe($scope.settingData).then((response) => {
				if (response.data.status) {
					$scope.secretKeyValidated = true;
				}

				// Validate publishable key
				var stripe = Stripe($scope.settingData.stripe_publishable_key);
				stripe.retrieveSource({
					id: 'src_123',
					client_secret: 'src_client_secret_123',
				}).then(function(result) {
					$timeout(function() {
						if (!result.error.message.includes('Invalid API Key')) {
							$scope.publishableKeyValidated = true;
						}
						$scope.validating = false;
						$scope.validateAttempted = true;

						if ($scope.publishableKeyValidated && $scope.secretKeyValidated) {
							$scope.settingData.stripe_validated = true;
							AppSettingsSvc.update($scope.settingData).then((response) => {
								notify({
									message: 'Keys validated & saved'
								});
							});
						}
					});

				});
			});
		};

		$scope.submit = function (settingData) {
			var promise;
			promise = AppSettingsSvc.update(settingData);

			promise.then(function (response) {
				notify({
					message: 'Settings saved'
				});
			}, function (error) {
				$scope.errors = error;
			});

		}

	}]);



